import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CostCenters, CostCentersApi } from 'src/app/shared/models/UserMapping/UserMapping.interface';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserMappingService {

  constructor(private http: HttpClient) { }
  UserCostCenters(): Observable<CostCenters[]> {
    return this.http.get<CostCentersApi>(`${environment.apiUrl}/get_emp_cost_center`).pipe(
      map((res) => {
        return res.data;
      })
    );
  }

}
